const extractBase64Image = (src: string | null): string | null =>
    typeof src === 'string' ? src.replace(/^data:image\/.*?;base64,/, '') : src

export default extractBase64Image
